/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateOauthVerificationKeyInput = {|
  clientId?: ?string,
  redirectUri?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createOauthVerificationKeyMutationVariables = {|
  input: CreateOauthVerificationKeyInput
|};
export type createOauthVerificationKeyMutationResponse = {|
  +createOauthVerificationKey: ?{|
    +code: ?string
  |}
|};
export type createOauthVerificationKeyMutation = {|
  variables: createOauthVerificationKeyMutationVariables,
  response: createOauthVerificationKeyMutationResponse,
|};
*/


/*
mutation createOauthVerificationKeyMutation(
  $input: CreateOauthVerificationKeyInput!
) {
  createOauthVerificationKey(input: $input) {
    code
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOauthVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOauthVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOauthVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createOauthVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOauthVerificationKeyMutation(\n  $input: CreateOauthVerificationKeyInput!\n) {\n  createOauthVerificationKey(input: $input) {\n    code\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '389c735c26110d6465a7479ef7661bcf';

module.exports = node;
